import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'
import { getEntry } from 'src/api/contenfull'
import { EntryFields } from 'types/contenfull'
import { BlogSection } from './ProfileSection'
import { InformationSection } from './InformationSection'
import { OverContainerLoading, PLoadingC } from 'src/components'
import Lottie from 'lottie-react'
import Loading from 'src/components/layout/Main/loading.json'
import { useTranslations,useI18nInstance } from "src/provider/LocaleProvider";

export function DetailedBlogs() {
    const t = useTranslations()
    const i18n = useI18nInstance()
    const { id } = useParams()
    const [entry, setEntry] = useState<EntryFields | null>(null)

    useEffect(() => {
        if (id) {
            (async () => {
                const resp = await getEntry(String(id))
                setEntry((resp?.fields as EntryFields) || null)
            })()
        }
    }, [id])

    if (!entry) {
        return (
            <OverContainerLoading>
                <PLoadingC>
                    <Lottie animationData={Loading} loop={true} />
                </PLoadingC>
            </OverContainerLoading>
        )
    }

    return (
        <>
            {i18n.language === 'es' ? (
                <Helmet>
                    <title>
                        {entry.tittleContentEs}-{' '}
                        {t('WorldWile.complement.title')}
                    </title>
                    <meta name="description" content={entry.descriptionEs} />
                </Helmet>
            ) : (
                <Helmet>
                    <title>
                        {entry.tittleContent}- {t('WorldWile.complement.title')}
                    </title>
                    <meta name="description" content={entry.description} />
                </Helmet>
            )}

            <BlogSection Blog={entry} />
            <InformationSection Blog={entry} />
        </>
    )
}
